import { createContext } from "react";

export const NotificationContext = createContext({
  setToastMessage: (message, duration = 5000, type = "") => {
    console.log(`${message} ${duration} ${type}`);
    throw new Error("Wrap your app in NotificationProvider");
  }
});
